<template>
    <div v-loading="loading">
        <el-form
            ref="formRef"
            style=""
            :model="dataForm"
            :rules="rules"
            :disabled="loading"
            label-width="auto"
        >

            <el-form-item
                :label="i18n.tkey('lang_select_supplier_company')"
                prop="addinfo3"
            >
                <ServerCompanySelector ref="companySelectorRef" v-model="dataForm.addinfo3" />
            </el-form-item>

            <el-form-item
                :label="i18n.tkey('lang_mall_companycode')"
                prop="addinfo1"
            >
                <el-input
                    v-model="dataForm.addinfo1"
                    type="text"
                    autocomplete="off"
                />
            </el-form-item>

        </el-form>

        <div class="operation-btns">
            <el-button type="primary" @click="submitForm(formRef)" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
        </div>
    </div>
</template>

<script setup>

import {inject, reactive, ref, toRef} from "vue";
import ServerCompanySelector from "@/components/shopopee/company/serverCompanySelector.vue";
import record17Api from "@/request/record17Api";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";

const emits = defineEmits("save-complete")

const i18n = inject("i18n")

const loading = ref(false)

const formRef = ref(null)
const companySelectorRef = ref(null)
const userInfoRef = toRef(useUserinfo())

const rules = reactive({
    addinfo1: [
        { required: true, message: i18n.tkey("lang_select_pls") },
    ],
    addinfo3: [
        { required: true, message: i18n.tkey("lang_input_agent_host_company_code_pls") },
    ],
})

const dataForm = reactive({
    addinfo1: '',
    addinfo3: '',
})

const submitForm = (formEl) => {
    if (!formEl) return
    formEl.validate((valid) => {
        if (valid) {
            submitData()
        }
    })
}

function submitData(){
    loading.value = true

    const request = record17Api.insertAgentRecord
    const params = request.getParams()

    params.companycode = dataForm.companycode
    params.addinfo1 = dataForm.addinfo3
    params.addinfo2 = userInfoRef.value.login
    params.addinfo3 = userInfoRef.value.companycode

    request.send(params, (res) => {
        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_add_success"))
            emits("save-complete")
        }
    })


}

</script>

<style scoped>
.operation-btns {
    margin-top: 30px;
    text-align: center;
}
</style>